import React from "react";
import { Provider } from "react-redux";
import store from "./store";
var PUMSProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ React.createElement(Provider, {
        store: store
    }, children);
};
export default PUMSProvider;
PUMSProvider.propTypes = {};

//# sourceMappingURL=PUMSProvider.js.map